// Durations of the screen with the keys of story 169 ({{value}} min, {{hours}} h {{minutes}} min, {{days}} d {{hours}} h),
// the way the job footprint writes them: minutes under an hour, hours and minutes under a day, days and hours above.
export const formatDuration = (milliseconds, t_) => {
  const totalMinutes = Math.floor(Math.max(0, milliseconds) / 60000)
  if (totalMinutes < 60) return t_('{{value}} min', { value: totalMinutes })
  const totalHours = Math.floor(totalMinutes / 60)
  if (totalHours < 24) return t_('{{hours}} h {{minutes}} min', { hours: totalHours, minutes: totalMinutes % 60 })
  return t_('{{days}} d {{hours}} h', { days: Math.floor(totalHours / 24), hours: totalHours % 24 })
}
